<template>
  <div class="questionBank_info_list_set_type_8">
    <!-- 新增||编辑试题 - 心肺复苏题 -->
    <el-form ref="questionData" :model="questionData" label-width="120px" size="mini" :rules="questionDataRules">
      <el-form-item label="题目内容" prop="questionName" class="form-item" style="width: 100%;">
        <el-input size="small" show-word-limit maxlength="200" type="textarea" resize="none" rows="3" clearable
          placeholder="请输入题目内容" v-model="questionData.questionName">
        </el-input>
      </el-form-item>
      <el-form-item label="配分" prop="score" class="form-item">
        <el-input-number v-model="questionData.score" :precision="1" :step="1" :min="1" :max="100"
          label="请输入配分"></el-input-number>
      </el-form-item>
      <el-form-item label="最大组数" prop="cprMaxGroup" class="form-item">
        <el-input-number v-model="questionData.cprMaxGroup" :step="1" :min="1" :max="10"
                         label="请输入配分"></el-input-number>
      </el-form-item>
      <el-form-item label="每组达标得分" prop="cprGroupScore" class="form-item">
        <el-input-number v-model="questionData.cprGroupScore" :precision="1" :step="1" :min="1" :max="20"
                         label="请输入徒手按压通气循环完成一组可获得分值"></el-input-number>
      </el-form-item>
      <el-form-item label="弹题数量" prop="cprPopupNum" class="form-item">
        <el-input-number v-model="questionData.cprPopupNum" :step="1" :min="0" :max="10"
                         label="请输入弹题数量, 数值不能大于“最大组数”"></el-input-number>
      </el-form-item>
      <el-form-item class="btnBox">
        <el-button class="bgc-bv" @click="doClose">取消</el-button>
        <el-button class="bgc-bv" @click="getSure">保存</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>
<script>
import List from "@/mixins/List";

export default {
  name: "examinationAffairsManage_questionBank_info_list_set_type_4",
  components: {

  },
  props: {
    // 基本信息
    basicInfo: {
      bankId: "", // 题库id
      itemId: "", // 考核科目id
      subjectId: "", // 科目id
      itemCode: "", // 科目标识
      itemName: "", // 科目名称
      contentId: "", // 考核内容id
      questionId: "", // 考题id(编辑用)
      questionType: "", // 题目类型
    },
  },
  mixins: [List],

  data() {
    return {
      // 题目基础 - 数据
      questionData: {
        questionName: '单人徒手心肺复苏', // 题目内容
        score: "70",        // 配分
        cprMaxGroup: 5,     // 心肺复苏完成所需最大组数
        cprGroupScore: 14,  //完成一组徒手按压吹气循环得分
        cprPopupNum: 1,     //心肺复苏进行中弹题数量
      },
      // 题目基础 - 数据 - 校验
      questionDataRules: {
        questionType: [
          { required: true, message: '请选择题目类型', trigger: 'change' }
        ],
        questionName: [
          { required: true, message: "请输入题目内容", trigger: "blur" },
        ],
        score: [
          { required: true, message: "请输入配分", trigger: "blur" },
        ],
        cprMaxGroup: [
          { required: true, message: "请输入心肺复苏完成所需最大组数", trigger: "blur" },
        ],
        cprGroupScore: [
          { required: true, message: "请输入完成一组徒手按压吹气循环得分", trigger: "blur" },
        ],
        cprPopupNum: [
          { required: true, message: "请输入弹题数量, 数值不能大于“最大组数”", trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  mounted() {
  },
  created() {
    if (this.basicInfo.questionId) {
      this.getSubjectInfo();
    }
  },
  methods: {
    // 获取 - 试题详情
    getSubjectInfo() {
      this.$post("/biz/bank/pa-question-bank/getQuestion", {
        questionId: this.basicInfo.questionId
      }, 3000, true, 10)
        .then((res) => {
          this.questionData = { ...this.questionData, ...res.data };
        })
        .catch((err) => {
          return;
        });
    },
    // 取消
    doClose() {
      this.$router.back();
    },
    // 保存
    getSure() {
      this.$refs['questionData'].validate((valid) => {
        if (valid) {
          //数据关系校验
          if (this.questionData.score !== this.questionData.cprGroupScore * this.questionData.cprMaxGroup) {
            this.$message.error("考题配分必须等于每组达标分数乘以最大组数！");
            return;
          }
          if (this.questionData.cprPopupNum > this.questionData.cprMaxGroup) {
            this.$message.error("弹题数量不能超过最大组数");
            return;
          }
          let cData = {
            contentId: this.basicInfo.contentId, // 考核内容id
            questionId: this.basicInfo.questionId, // 考核内容id(有则编辑,无则添加)
            questionType: this.basicInfo.questionType, // 题目类型
            ...this.questionData,
          }
          this.$post("/biz/bank/pa-question-bank/itemQuestionSaveUpdate", cData, 3000, true, 10)
            .then((res) => {
              this.$message.success('操作成功');
              this.$refs['questionData'].resetFields();
              this.questionData = this.$options.data().questionData;
              // 编辑试题 - 编辑完自动返回上一页
              if (this.basicInfo.questionId) {
                this.doClose();
              }
            })
            .catch((err) => {
              return;
            });
        }
      })
    },
  },
};
</script>
<style lang="less" scoped></style>
